var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderVector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 168,
    viewBox: "0 0 167 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167 83.5C167 60.4428 148.307 41.75 125.25 41.75L142.553 24.4606C126.246 8.15353 99.8071 8.15353 83.5 24.4606V0C60.4428 0 41.75 18.6928 41.75 41.75L24.4606 24.4606C8.15353 40.7677 8.15353 67.1929 24.4606 83.5H0C0 106.557 18.6928 125.25 41.75 125.25L24.4466 142.553C40.7536 158.861 67.1929 158.861 83.486 142.553V167.014C106.543 167.014 125.236 148.321 125.236 125.264L142.525 142.553C158.832 126.246 158.832 99.8211 142.525 83.514H166.986L167 83.5Z",
    fill: "#F4DB49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderVector);
export default __webpack_public_path__ + "static/media/slider-vector.11d90252fa9f25b19c7dddf14f78986d.svg";
export { ForwardRef as ReactComponent };